import workspaceQuery from 'graphql/queries/supplier/PurchasePaymentMethodWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/PurchasePaymentMethodListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchasePaymentMethodQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchasePaymentMethodDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchasePaymentMethodMutation.graphql';
import fragment from 'graphql/fragments/supplier/PurchasePaymentMethodFragment.graphql';

const PurchasePaymentMethod = {
  type: 'PurchasePaymentMethod',
  title: 'Purchase Payment Methods',
  formTitle: 'Payment Method',
  formUrl: '/Suppliers/PaymentMethod/Details/',
  workspaceUrl: '/Suppliers/PaymentMethod/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SUPPLIER_PAYMENT_METHODS',
};

export default PurchasePaymentMethod;
